import * as yup from 'yup';
import { requiredErrorMessage } from 'shared/consts';

export const validationSchema = yup.object().shape({
  commission_min: yup
    .string()
    .test(
      'minus_value',
      'Поле "Минимальная комиссия" не может быть пустым, минимальное значение 0',
      (value) => value !== undefined && Number(value) >= 0 && value.length > 0,
    ),
  commission_percent: yup
    .string()
    .test(
      'minus_value',
      'Поле "Комиссия,%" не может быть пустым, минимальное значение 0',
      (value) => value !== undefined && Number(value) >= 0 && value.length > 0,
    ),
  limit: yup
    .string()
    .test(
      'non_negative',
      'Поле "Лимит" не может быть отрицательным числом',
      (value) => value === undefined || value === '' || Number(value) >= 0,
    ),
  city_ids: yup.array().of(yup.number()),
  is_needed_validation: yup.boolean().required(requiredErrorMessage),
});
